module.exports = __webpack_public_path__ + "img/spins_10.71ae1c24.png";